import React, { useEffect, useState } from 'react';
import {
  Card, Typography, Grid, TextField, Button, IconButton,
  InputAdornment, MenuItem, Box
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import axios from 'axios';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';

const API_URL = process.env.REACT_APP_API_URL;

function AdminCreateCoupon() {
  const [newCoupon, setNewCoupon] = useState({
    coupon_code: '',
    discount: '',
    employee_mappings_id: '',
  });

  const [representatives, setRepresentatives] = useState([]);

  const handleCouponChange = (e) => {
    setNewCoupon({
      ...newCoupon,
      [e.target.name]: e.target.value,
    });
  };

  const generateCouponCode = () => {
    const prefix = "EDU";
    const suffix = Math.random().toString(36).substring(2, 6).toUpperCase();
    const datePart = new Date().getFullYear().toString().slice(-2);
    const generated = `${prefix}${datePart}${suffix}`;
    setNewCoupon({ ...newCoupon, coupon_code: generated });
  };

  useEffect(() => {
    axios.get(`${API_URL}/api/anthra-representatives/`)
      .then((res) => {
        setRepresentatives(res.data);
      })
      .catch((err) => {
        console.error('Error fetching representatives:', err);
      });
  }, []);

  const handleCreateCoupon = () => {
    const { coupon_code, discount, employee_mappings_id } = newCoupon;

    if (!coupon_code || !discount || !employee_mappings_id) {
      alert("All fields are required.");
      return;
    }

    axios.post(`${API_URL}/api/coupon/create/`, newCoupon)
      .then(() => {
        alert('Coupon created!');
        setNewCoupon({ coupon_code: '', discount: '', employee_mappings_id: '' });
      })
      .catch((err) => {
        console.error(err);
        alert('Error creating coupon');
      });
  };

  return (
    <div>
  <Header1 />

  <Card
    sx={{
      p: 4,
      maxWidth: 900,
      margin: '0 auto',
      backgroundColor: '#1e1e1e',
      boxShadow: 5,
      borderRadius: 3,
      border: '1px solid #333',
    }}
  >
    <Typography
      variant="h4"
      gutterBottom
      sx={{ color: '#ffffff', textAlign: 'center', mb: 4, letterSpacing: 2 }}
    >
      Create New Coupon
    </Typography>

    <Box
      display="flex"
      flexWrap="wrap"
      gap={3}
      justifyContent="space-between"
    >
      {/* Coupon Code */}
      <Box flex="1 1 250px">
        <TextField
          name="coupon_code"
          label="Coupon Code"
          fullWidth
          value={newCoupon.coupon_code}
          onChange={handleCouponChange}
          InputLabelProps={{ style: { color: '#ccc' } }}
          InputProps={{
            style: { color: '#fff', backgroundColor: '#2b2b2b' },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={generateCouponCode} edge="end" sx={{ color: '#ccc' }}>
                  <AutorenewIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* Discount */}
      <Box flex="1 1 250px">
        <TextField
          name="discount"
          label="Discount (%)"
          type="number"
          fullWidth
          inputProps={{ min: 0, max: 100 }}
          value={newCoupon.discount}
          onChange={handleCouponChange}
          InputLabelProps={{ style: { color: '#ccc' } }}
          InputProps={{ style: { color: '#fff', backgroundColor: '#2b2b2b' } }}
        />
      </Box>

      {/* Representative Dropdown */}
      <Box flex="1 1 250px">
        <TextField
          select
          name="employee_mappings_id"
          label="Representative"
          fullWidth
          value={newCoupon.employee_mappings_id}
          onChange={handleCouponChange}
          InputLabelProps={{ style: { color: '#ccc' } }}
          InputProps={{ style: { color: '#fff', backgroundColor: '#2b2b2b' } }}
        >
          {representatives.map((rep) => (
            <MenuItem key={rep.id} value={rep.id}>
              {rep.user_name}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      {/* Submit Button */}
      <Box flex="1 1 100%">
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateCoupon}
          fullWidth
          sx={{
            backgroundColor: '#1E90FF',
            color: '#fff',
            fontWeight: 'bold',
            padding: '14px',
            letterSpacing: 2,
            fontSize: '1.1rem',
            borderRadius: 2,
            '&:hover': {
              backgroundColor: '#0077cc',
              transform: 'scale(1.03)',
              transition: '0.3s',
            },
          }}
        >
          Create Coupon
        </Button>
      </Box>
    </Box>
  </Card>

  <Footer2 />
</div>

  );
}

export default AdminCreateCoupon;
